/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type BulkSigningCsvUrlsInput = {
    id: string;
    clientMutationId?: string | null;
};
export type bulkSigningCsvUrlsMutationVariables = {
    input: BulkSigningCsvUrlsInput;
};
export type bulkSigningCsvUrlsMutationResponse = {
    readonly bulkSigningCsvUrls: {
        readonly uploadUrl: string | null;
        readonly sampleUrl: string | null;
    } | null;
};
export type bulkSigningCsvUrlsMutation = {
    readonly response: bulkSigningCsvUrlsMutationResponse;
    readonly variables: bulkSigningCsvUrlsMutationVariables;
};



/*
mutation bulkSigningCsvUrlsMutation(
  $input: BulkSigningCsvUrlsInput!
) {
  bulkSigningCsvUrls(input: $input) {
    uploadUrl
    sampleUrl
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BulkSigningCsvUrlsPayload",
    "kind": "LinkedField",
    "name": "bulkSigningCsvUrls",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uploadUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sampleUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bulkSigningCsvUrlsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bulkSigningCsvUrlsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "64ccbde8745761689157cbe6b762aded",
    "id": null,
    "metadata": {},
    "name": "bulkSigningCsvUrlsMutation",
    "operationKind": "mutation",
    "text": "mutation bulkSigningCsvUrlsMutation(\n  $input: BulkSigningCsvUrlsInput!\n) {\n  bulkSigningCsvUrls(input: $input) {\n    uploadUrl\n    sampleUrl\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f25a705137184bbc8a9beedc0970892d';
export default node;
